// extracted by mini-css-extract-plugin
export default {"main":"company_main__EybS6","title":"company_title__H20Tp","image":"company_image__x3khB","box":"company_box__Slqpi","gif":"company_gif__KrXp+"};